import React from "react";

import { Navbar } from "../components";

const CardLayout = ({ children }) => {
  return (
    <>
      <Navbar minimal showLogout isOpen={false} />
      <div className="flex items-center justify-center w-screen h-screen px-4 md:px-0">
        <div className="py-4 px-4 md:py-8 md:px-12 bg-white shadow-lg rounded-lg max-w-xl w-full">
          {children}
        </div>
      </div>
    </>
  );
};

export default CardLayout;
